<template>
  <div id="subscription" class="payment-wrapper">
    <form id="subscribe" action="https://us-central1-stripe-firebase-133c0.cloudfunctions.net/subscription"  method='post' novalidate='true'>
      <h3>Monthly Subscription</h3>
      <h1>$199</h1>
    </form>
  </div>
</template>
<script>
  export default {
    name: 'Subscription',
    data () {
      return {
      }
    },
    mounted () {
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://checkout.stripe.com/checkout.js')
      recaptchaScript.setAttribute('class', 'stripe-button')
      recaptchaScript.setAttribute('data-key', 'pk_live_xse9yr0bV5ZUDzljrD0nAArN')
      recaptchaScript.setAttribute('data-image', '')
      recaptchaScript.setAttribute('data-name', 'Ghost Inc.')
      recaptchaScript.setAttribute('data-description', 'Monthly Subscription')
      recaptchaScript.setAttribute('data-amount', '19900')
      recaptchaScript.setAttribute('data-label', 'Pay')
      document.getElementById('subscribe').appendChild(recaptchaScript)
    },
    methods: {
      sendToken: function (e) {
        e.preventDefault()
        var formData = new FormData(document.getElementById('subscribe'))
        console.log(formData)
      }
    }
}
</script>







// WEBPACK FOOTER //
// src/components/Subscription.vue